import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.push.js";
import { __decorate } from "tslib";
import MainTitle from '@/components/title/MainTitle.vue';
import { Options, Vue } from 'vue-class-component';
import store from '@/store';
import { router } from "@/router";
import AuthLinksTable from '@/components/authLink/AuthLinksTable.vue';
import AuthLinkForm from "@/views/authLink/AuthLinkForm.vue";
import CenterTop from "@/components/layout/CenterTop.vue";
let AuthItemList = class AuthItemList extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "errorMsg", '');
    _defineProperty(this, "toggleAuthLinkFormDialog", false);
  }
  mounted() {
    if (!this.isAuthItem) {
      router.push({
        name: 'HomePage'
      });
    }
  }
  get isCreateAuthLink() {
    return store.getters.isAuthLinkCreateAivailable;
  }
  get isAuthItem() {
    return store.getters.isAuthItemAvailable;
  }
};
AuthItemList = __decorate([Options({
  components: {
    AuthLinksTable,
    CenterTop,
    MainTitle,
    AuthLinkForm
  }
})], AuthItemList);
export default AuthItemList;